'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconBell, iconBellTag } from '@ni/nimble-components/dist/esm/icons/bell';
import { wrap } from '../../utilities/react-wrapper';

export type { IconBell };
export { iconBellTag };
export const NimbleIconBell = wrap(IconBell);